import { PCImage } from 'app/design/primitives/image';
import { ChannelRow } from './channel';

import { type MemberChannel as MemberChannelType } from 'app/types/chat';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

const MemberChannel = function MemberChannel(channel: MemberChannelType) {
  const prefix = (
    <PCImage
      aspectRatio={1}
      height={60}
      source={{ uri: channel.picture }}
      style={{
        borderRadius: theme.borderRadii['radius.full'],
      }}
    />
  );
  return <ChannelRow channel={channel} prefix={prefix} />;
};

export { MemberChannel };
